var chunkMapping = {
	"36": [
		4929
	],
	"59": [
		9816
	],
	"110": [
		1418
	],
	"140": [
		6140
	],
	"143": [
		5095
	],
	"147": [
		2491
	],
	"368": [
		2828
	],
	"464": [
		4559
	],
	"477": [
		5686
	],
	"539": [
		2291
	],
	"582": [
		4323
	],
	"691": [
		1909
	],
	"718": [
		7775
	],
	"782": [
		6083
	],
	"954": [
		9404
	],
	"967": [
		4688
	],
	"974": [
		9419
	]
};
var idToExternalAndNameMapping = {
	"1418": [
		"default",
		"./EmailBuilderApp",
		5864
	],
	"1909": [
		"default",
		"./POSBackOfficeApp",
		6724
	],
	"2291": [
		"default",
		"./ProductManagementApp",
		3729
	],
	"2491": [
		"default",
		"./WebsiteBuilderApp",
		662
	],
	"2828": [
		"default",
		"./CustomerAuthenticationApp",
		7205
	],
	"4323": [
		"default",
		"./AuthApp",
		7384
	],
	"4559": [
		"default",
		"./SidebarApp",
		7367
	],
	"4688": [
		"default",
		"./MarketingApp",
		639
	],
	"4929": [
		"default",
		"./DynamicFormsAdminApp",
		4411
	],
	"5095": [
		"default",
		"./ServicesApp",
		1204
	],
	"5686": [
		"default",
		"./BookingBuilderApp",
		8380
	],
	"6083": [
		"default",
		"./HeaderApp",
		5281
	],
	"6140": [
		"default",
		"./IdleSessionApp",
		1501
	],
	"7775": [
		"default",
		"./POSApp",
		3276
	],
	"9404": [
		"default",
		"./DynamicFormsApp",
		5990
	],
	"9419": [
		"default",
		"./OffersApp",
		5997
	],
	"9816": [
		"default",
		"./EcommerceApp",
		2091
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}